import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCountry } from "@/contexts/CountryContext";
import { SUPPORTED_COUNTRIES } from "@/lib/geo";

// Country names rendered via Intl.DisplayNames so they auto-translate to the
// active UI language (es, en, fr, etc.).
function countryName(code, locale) {
    try {
        const dn = new Intl.DisplayNames([locale, "en"], { type: "region" });
        const out = dn.of(code === "UK" ? "GB" : code);
        return out || code;
    } catch {
        return code;
    }
}

export default function CountrySelector({ compact = false }) {
    const { country, setCountry } = useCountry();
    const { t, i18n } = useTranslation();
    const lang = (i18n.language || "en").split("-")[0];

    return (
        <label
            className={`inline-flex items-center gap-2 text-xs text-[var(--ink-muted)] ${
                compact ? "" : "border border-[var(--border-strong)] rounded-full px-4 py-2 bg-[var(--bg-elevated)]"
            }`}
        >
            <Globe size={14} strokeWidth={1.5} className="text-[var(--ink)]" />
            <span className="uppercase tracking-widest sr-only">{t("country.label")}</span>
            <select
                data-testid="country-selector"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="bg-transparent border-0 outline-none text-[var(--ink)] text-sm cursor-pointer"
            >
                {SUPPORTED_COUNTRIES.map((c) => (
                    <option key={c.code} value={c.code}>
                        {countryName(c.code, lang)}
                    </option>
                ))}
            </select>
        </label>
    );
}
